module.exports = __webpack_public_path__ + "static/intro-image-c764ba2fe577a6da9e2bcc7784bcff33.png";